// 2 palette selezionabili a runtime nel MockupHub
export const themes = {
  slate: {
    name: 'Enterprise Slate',
    desc: 'Charcoal + Cobalt + Emerald · stile Linear/Vercel',
    bg: '#0B0F19', bgDeep: '#060912',
    surf: '#131724', surfLight: '#1B2030',
    surfGlass: 'rgba(19, 23, 36, 0.65)',
    gold: '#3B82F6', goldDark: '#2563EB',
    goldGlow: 'rgba(59, 130, 246, 0.28)',
    terra: '#EF4444', terraGlow: 'rgba(239, 68, 68, 0.28)',
    emerald: '#10B981', emeraldDark: '#047857',
    cyan: '#22D3EE', amber: '#F59E0B',
    text: '#F1F5F9', textSec: '#94A3B8', textDim: '#475569',
    border: 'rgba(148, 163, 184, 0.10)',
    borderStrong: 'rgba(148, 163, 184, 0.20)',
  },
  corporate: {
    name: 'Corporate Banca',
    desc: 'Navy istituzionale + Steel + verde solo per success',
    bg: '#0A1628', bgDeep: '#050D19',
    surf: '#0F1F35', surfLight: '#162947',
    surfGlass: 'rgba(15, 31, 53, 0.7)',
    gold: '#4A6FA5', goldDark: '#3A5985',
    goldGlow: 'rgba(74, 111, 165, 0.18)',
    terra: '#B83C3C', terraGlow: 'rgba(184, 60, 60, 0.20)',
    emerald: '#2D8C5C', emeraldDark: '#1E6E45',
    cyan: '#5E8FB0', amber: '#C49356',
    text: '#E8EEF5', textSec: '#8FA2BC', textDim: '#4D6885',
    border: 'rgba(143, 162, 188, 0.12)',
    borderStrong: 'rgba(143, 162, 188, 0.22)',
  },
};

// C è un oggetto MUTABILE: gli screen leggono `C.bg`, `C.gold`, ecc. al rendering.
// Quando l'utente cambia tema, mutiamo C e forziamo remount con key={themeName}.
export const C = { ...themes.corporate };

// primaryBtn / secondaryBtn / overline sono oggetti che molti screen "spreadano" via {...primaryBtn}.
// Per farli rispondere al cambio tema, li sovrascriviamo nello stesso riferimento.
export const primaryBtn = {};
export const secondaryBtn = {};
export const overline = {};

function recomputeStyles() {
  Object.assign(primaryBtn, {
    background: C.gold, color: '#fff', border: 'none', padding: '10px 18px',
    borderRadius: 8, fontWeight: 600, fontSize: 13, cursor: 'pointer',
    display: 'inline-flex', alignItems: 'center', gap: 6,
    boxShadow: `0 1px 0 ${C.goldDark}, 0 4px 14px ${C.goldGlow}`,
  });
  Object.assign(secondaryBtn, {
    background: 'transparent', color: C.text,
    border: `1px solid ${C.border}`, padding: '10px 18px',
    borderRadius: 8, fontWeight: 500, fontSize: 13, cursor: 'pointer',
  });
  Object.assign(overline, {
    fontSize: 10.5, letterSpacing: '0.14em', textTransform: 'uppercase',
    color: C.textSec, fontWeight: 600,
  });
}
recomputeStyles();

export function applyTheme(name) {
  const t = themes[name] || themes.slate;
  // Mantieni le altre chiavi e sovrascrivi solo quelle del tema
  Object.keys(t).forEach(k => { C[k] = t[k]; });
  recomputeStyles();
}

export const fontHead = "'Inter', 'Geist', system-ui, sans-serif";
export const fontBody = "'Inter', system-ui, sans-serif";
